import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/automations")({
  component: Outlet,
  staticData: {
    getBreadcrumb() {
      return {
        id: "automations",
        labelTranslationKey: "automationsPage.title",
        href: "/automations",
      };
    },
  },
});
